var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"has-text-centered"},[_c('p',{staticClass:"my-2 has-text-grey-lighter has-text-weight-bold"},[_vm._v(" "+_vm._s(_vm.$d(new Date(), 'long'))+" ")])]),_c('ChatBody',{attrs:{"messages":_vm.messages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }